export const accountBookings = {
  DELETE_ACCOUNT_MODAL_OPEN: 'accountbookings.openDeleteAccountModalButton',
  ACCOUNT_DELETED: 'accountbookings.deleteAccountButton',
  BOOKING_CARD_CLICKED: 'accountbookings.bookingCard',
  PAST_BOOKING_CARD_CLICKED: 'accountbookings.pastBookingCard',
  ADD_BOOKING_MODAL_OPEN: 'accountbookings.addBookingModalOpen',
  ADD_BOOKING_SUCCEEDED_MODAL_CLOSE: 'accountbookings.addBookingSucceededModalClose',
  ADD_BOOKING_FAILED_MODAL_CLOSE: 'accountbookings.addBookingFailedModalClose'
}
